// extracted by mini-css-extract-plugin
module.exports = {"imgCarousel":"carouselOneProductStyle_imgCarousel__3YwfB"};